import { ThemedLink } from '@Components/MuiWrappers/ThemedLink';

const SEOLink = (props) => {
    return (props.IsHostedSite ? (
                    <li className={props.HideLink ? 'hide-link' : ''}>
                        <ThemedLink href={props.Url} underline='hover' className={props.IsParent ? 'internal-link-parent' : ''} sx={{ 'paddingLeft': ((props.Indent || 0) * 10) + 'px' }}>
                            {props.DisplayText}
                        </ThemedLink>
                    </li>
            ) : ( 
            <li className={props.HideLink ? 'hide-link' : ''}>
                {props.Url ?
                    (<a className={props.IsParent ? 'internal-link-parent' : ''} style={{ 'paddingLeft': ((props.Indent || 0) * 10) + 'px' }} href={props.Url}>
                        {props.DisplayText}
                    </a>)
                    :
                    (<div className={props.IsParent ? 'internal-link-parent' : ''} style={{ 'paddingLeft': ((props.Indent || 0) * 10) + 'px' }}>{props.DisplayText}</div> )
                }
            </li>)
        );
    };

export default SEOLink;